// import React, { useState } from "react";
import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle25 from "../../randing/RandingStyle25";

function Randing345({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <>
      {/* Google Tag Manager [HEAD] */}
      <Helmet>
        <script>
          {`
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-NBSQTDJW');
          `}
        </script>
      </Helmet>
      {/* Google Tag Manager [BODY] */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-NBSQTDJW"
          height="0"
          width="0"
          title="gtm"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>

      <RandingStyle25
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/345/01.jpg`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/345/02.webp`}
        qOptionColor="blue"
        formFieldColor="white"
        benefitInfoPosition="bottom"
        companyName="본원"
        privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/dlatl.jpg`}
        eventDates={true}
        apiUrl={apiUrl}
      />
    </>
  );
}

export default Randing345;
